import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { MiniQuestionnaireData } from "@/types/miniQuestionnaire";

interface MiniSection1Props {
  data: MiniQuestionnaireData;
  updateData: (field: keyof MiniQuestionnaireData, value: string) => void;
}

const MiniSection1 = ({ data, updateData }: MiniSection1Props) => {
  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-semibold text-feel-foreground mb-6">
        Questions initiales
      </h2>

      {/* Question 1 - Âge */}
      <div className="space-y-3">
        <Label htmlFor="age" className="text-lg font-medium text-feel-foreground">
          Q1. Quel âge avez-vous ?
        </Label>
        <Input
          id="age"
          type="number"
          placeholder="Votre âge"
          value={data.age}
          onChange={(e) => updateData("age", e.target.value)}
          className="max-w-[200px]"
          min="1"
          max="120"
        />
      </div>

      {/* Question 2 - Sexe */}
      <div className="space-y-3">
        <Label className="text-lg font-medium text-feel-foreground">
          Q2. Quel est votre sexe ?
        </Label>
        <RadioGroup
          value={data.sexe}
          onValueChange={(value) => updateData("sexe", value)}
          className="space-y-2"
        >
          <div className="flex items-center space-x-3">
            <RadioGroupItem value="homme" id="sexe-homme" />
            <Label htmlFor="sexe-homme" className="cursor-pointer">Homme</Label>
          </div>
          <div className="flex items-center space-x-3">
            <RadioGroupItem value="femme" id="sexe-femme" />
            <Label htmlFor="sexe-femme" className="cursor-pointer">Femme</Label>
          </div>
        </RadioGroup>
      </div>

      {/* Question 3 - Tabac régulier */}
      <div className="space-y-3">
        <Label className="text-lg font-medium text-feel-foreground">
          Q3. Avez-vous déjà fumé régulièrement (au moins 1 cigarette par jour pendant au moins un an) ?
        </Label>
        <RadioGroup
          value={data.tabac_regulier}
          onValueChange={(value) => updateData("tabac_regulier", value)}
          className="space-y-2"
        >
          <div className="flex items-center space-x-3">
            <RadioGroupItem value="oui" id="tabac-oui" />
            <Label htmlFor="tabac-oui" className="cursor-pointer">Oui</Label>
          </div>
          <div className="flex items-center space-x-3">
            <RadioGroupItem value="non" id="tabac-non" />
            <Label htmlFor="tabac-non" className="cursor-pointer">Non</Label>
          </div>
        </RadioGroup>
      </div>
    </div>
  );
};

export default MiniSection1;
